import { render, staticRenderFns } from "./EditNBCollector.vue?vue&type=template&id=42f6f75c&"
import script from "./EditNBCollector.vue?vue&type=script&lang=js&"
export * from "./EditNBCollector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports